import { Typography } from '@mui/material';
import Grid from 'components/core/Grid';
import { listPropertyPayouts } from 'config/imageUrls';
import { ContentSection } from './styles';

export const PayoutsTaxes = () => {
  return (
    <>
      <ContentSection>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
            <img src={listPropertyPayouts} width="100%" />
          </Grid>
          <Grid item xs={12} sm={8}>
            <Typography variant="h2" mb={2}>
              Payouts and Taxes Made Easy
            </Typography>
            <Typography mb={2}>
              Guests pay securely by credit card through our website and you receive payouts to your Canadian bank
              account when the guest arrives at your property. This process is the same across most hosting platforms to
              ensure for streamlined management and accounting processes.
            </Typography>
            <Typography mb={2}>
              alluraDirect is a locally owned company (Vancouver, BC) that is focussed on Canadian ski resort vacation
              rentals - this allows us to make taxes easier for you and your property.
            </Typography>
            <Typography mb={1}>
              <strong>Federal Tax (GST):</strong> Mandatory tax for all short-term rentals located in Canada.
            </Typography>
            <Typography mb={1}>
              <strong>Provincial Tax (PST):</strong> Mandatory tax for all short-term rentals located in British
              Columbia.
            </Typography>
            <Typography mb={1}>
              <strong>Provincial Tax (MRDT):</strong> Mandatory tax for all short-term rentals in specific locations.
            </Typography>
            <Typography mb={2}>
              <strong>Non-Resident Withholding (NR4):</strong> Automatic withholding and remittance. NR6 application
              available.
            </Typography>
            <Typography>
              We can remit directly to the tax authorities on your behalf or can pass-through the collected taxes for
              self remittance if you have a registered tax number - we make your rental tax obligations easy.
            </Typography>
          </Grid>
        </Grid>
      </ContentSection>
    </>
  );
};
